export const campoObrigatorio = 'Esse campo é obrigatório.'
export const campoDeveSerMaiorQueZero = 'O valor deve ser maior que 0.'
export const campoDeveSerMenor = 'O valor deve ser menor que '
export const campoDeveSerMaiorIgual = 'O valor deve ser maior ou igual que '
export const campoDeveSerMenorIgual = 'O valor deve ser menor ou igual a'
export const campoInvalido = 'Valor do campo inválido.'
export const campoDeveSerMenorIgualCampo = 'O valor deve ser menor ou igual que o campo'
export const campoDeveSerMaiorIgualCampo = 'O valor deve ser maior ou igual que o campo'
export const campoOpcional = 'Campo Opcional'
export const secaoOpcional = 'Seção Opcional'
export const processandoDados = 'Os dados estão sendo processados ...'
export const erroIndisponibilidade = 'O sistema se encontra indisponível neste momento.'
export const ajudaMuroExterno = 'O valor do Muro Externo se refere ao muro do condomínio inteiro.'
export const ajudaColchaoLancamento = 'O período deve ser entre 1 à 12 meses.'
export const ajudaCurvaVendas = 'O período deve ser entre 1 à 36 meses.'

export const campoDeveEstarEntreValor1eValor2 = (valor1: number, valor2: number) => `Valor do campo deve estar entre ${valor1} e ${valor2}`

export const helperTextErroCampoOpcional = (mensagemErro: string) => {
  return mensagemErro != '' ? `${mensagemErro} (${campoOpcional})` : campoOpcional
}
